export const DIMENSIONS = {
  guide: {
    width: 280,
    height: 420,
  },
  journey: {
    width: 280,
    height: 420,
  },
  collection: {
    width: 280,
    height: 330,
  },
  certification: {
    width: 280,
    height: 330,
  },
  tom: {
    width: 280,
    height: 330,
  },
  story: {
    width: 128,
    height: 128,
  },
  storyCategory: {
    width: 120,
    height: 68,
  },
  instructor: {
    width: 120,
    height: 120,
  },
  quizCoverImage: {
    width: 375,
    height: 132,
  },
  aiExerciseCategory: {
    width: 319,
    height: 181,
  },
  aiExercise: {
    width: 343,
    height: 343,
  },
  rnpIcon: {
    width: 200,
    height: 200,
  },
  rnpLogo: {
    width: 200,
    height: 200,
  },
  issuerLogo: {
    width: 200,
    height: 200,
  },
  issuerIcon: {
    width: 200,
    height: 200,
  },
};
